import { useRef as l, useCallback as i } from "react";
import c from "swr";
import { useTrackedSWRKey as m } from "./index41.mjs";
const A = (n, o, s, a = !0) => {
  m(n);
  const t = l(void 0), u = i(() => {
    var r;
    return (r = t.current) == null ? void 0 : r.abort();
  }, []);
  return { ...c(
    a ? n : void 0,
    (r) => {
      const e = Array.isArray(r) ? r[0] : r;
      return t.current = new AbortController(), o == null ? void 0 : o(e, { signal: t.current.signal });
    },
    s
  ), abort: u };
};
export {
  A as useControlledSwr
};
